import {updateCurrentOptions} from './options'
import {
  updateDomAddButton,
  maybeSetOptionSelected,
  updateVariantIdInput,
  swapProductInfo
} from './dom'
import {compareInputValues, shouldShowBISForVariant} from './helpers'
import {
  ADD_BUTTON_TEXT_UNAVAILABLE_STRING,
  VARIANTS_JSON_SELECTOR
} from './const'

function updateCurrentVariant() {
  try {
    const variants = getVariantData()
    if (!variants || !Array.isArray(variants)) {
      console.error('No variants data found')
      return
    }

    // Si une seule variante, la sélectionner directement
    if (variants.length === 1) {
      window.prodify.currentVariant = variants[0]
      return
    }

    const matchingVariant = variants.find(
      variant => {
        return variant.options.every((option, index) => {
          return window.prodify.options[index] === option
        })
      })

    if (!matchingVariant) {
      console.warn('No matching variant found for current options')
      window.prodify.currentVariant = null
      return
    }

    window.prodify.currentVariant = matchingVariant
  } catch (error) {
    console.error('Error updating current variant:', error)
    window.prodify.currentVariant = null
  }
}

function onVariantChange(event) {
  try {
    if (!event || !event.target) {
      console.error('Invalid event in onVariantChange')
      return
    }

    updateCurrentOptions()
    updateCurrentVariant()
    updateDomAddButton(true, '', false, true)
    compareInputValues()

    const optionIndex = parseInt(event.target.dataset.optionPosition || '1')
    maybeSetOptionSelected(event.target, optionIndex)

    if (!window.prodify.currentVariant) {
      updateDomAddButton(true, ADD_BUTTON_TEXT_UNAVAILABLE_STRING, true, false)
    } else {
      updateVariantIdInput()
      swapProductInfo()
      
      const bisElement = document.getElementById('BIS_trigger')
      if (bisElement && window.prodify.currentVariant) {
        const currentVariant = window.prodify.currentVariant
        
       
        bisElement.setAttribute('data-variant-id', currentVariant.id.toString())
        
      
        const shouldShow = shouldShowBISForVariant(currentVariant)
        
        bisElement.style.display = shouldShow ? 'block' : 'none'
      }
    }
  } catch (error) {
    console.error('Error in onVariantChange:', error)
    updateDomAddButton(true, ADD_BUTTON_TEXT_UNAVAILABLE_STRING, true, false)
  }
}

function getVariantData() {
  try {
    if (!window.prodify.variantData) {
      const variantJsonElement = window.prodify.el.querySelector(VARIANTS_JSON_SELECTOR)
      if (!variantJsonElement) {
        throw new Error('Variant JSON element not found')
      }
      window.prodify.variantData = JSON.parse(variantJsonElement.textContent)
    }
    return window.prodify.variantData
  } catch (error) {
    console.error('Error getting variant data:', error)
    return []
  }
}



export {
  updateVariantIdInput,
  updateCurrentVariant,
  onVariantChange,
  getVariantData
}
